"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessUnitToOrganizationSlug = exports.DomainBrandToBusinessUnit = exports.BusinessUnitToBrandSlug = exports.OrganizationSlugToBusinessUnit = exports.OrganizationNameToBusinessUnit = exports.OrganizationSlug = exports.OrganizationName = exports.BusinessUnitToBrandName = exports.BusinessUnit = exports.BusinessUnitsEnum = void 0;
var BusinessUnitsEnum;
(function (BusinessUnitsEnum) {
    BusinessUnitsEnum["BOTICARIO"] = "boticario";
    BusinessUnitsEnum["EUDORA"] = "eudora";
    BusinessUnitsEnum["EU_AMO_MAKE"] = "euamomake";
    BusinessUnitsEnum["OUI"] = "oui";
    BusinessUnitsEnum["MLT"] = "multibrand";
})(BusinessUnitsEnum = exports.BusinessUnitsEnum || (exports.BusinessUnitsEnum = {}));
var BusinessUnit;
(function (BusinessUnit) {
    BusinessUnit["BOT"] = "boticario";
    BusinessUnit["EUD"] = "eudora";
    BusinessUnit["EAM"] = "euamomake";
    BusinessUnit["OUI"] = "oui";
    BusinessUnit["MLT"] = "multibrand";
})(BusinessUnit = exports.BusinessUnit || (exports.BusinessUnit = {}));
var BusinessUnitToBrandName;
(function (BusinessUnitToBrandName) {
    BusinessUnitToBrandName["boticario"] = "BOTICARIO";
    BusinessUnitToBrandName["eudora"] = "EUDORA";
    BusinessUnitToBrandName["euamomake"] = "EU_AMO_MAKE";
    BusinessUnitToBrandName["oui"] = "OUI";
    BusinessUnitToBrandName["mlt"] = "MULTIBRAND";
})(BusinessUnitToBrandName = exports.BusinessUnitToBrandName || (exports.BusinessUnitToBrandName = {}));
var OrganizationName;
(function (OrganizationName) {
    OrganizationName["BOTICARIO"] = "O BOTIC\u00C1RIO";
    OrganizationName["EUDORA"] = "EUDORA";
    OrganizationName["EU_AMO_MAKE"] = "EU AMO MAKE";
    OrganizationName["OUI"] = "O.U.I PARIS";
    OrganizationName["QUEM_DISSE_BERENICE"] = "QUEM DISSE, BERENICE?";
})(OrganizationName = exports.OrganizationName || (exports.OrganizationName = {}));
var OrganizationSlug;
(function (OrganizationSlug) {
    OrganizationSlug["BOT"] = "BOT";
    OrganizationSlug["EUD"] = "EUD";
    OrganizationSlug["EAM"] = "EAM";
    OrganizationSlug["OUI"] = "OUI";
    OrganizationSlug["QDB"] = "QDB";
})(OrganizationSlug = exports.OrganizationSlug || (exports.OrganizationSlug = {}));
exports.OrganizationNameToBusinessUnit = {
    [OrganizationName.BOTICARIO]: BusinessUnit.BOT,
    [OrganizationName.EUDORA]: BusinessUnit.EUD,
    [OrganizationName.EU_AMO_MAKE]: BusinessUnit.EAM,
    [OrganizationName.QUEM_DISSE_BERENICE]: BusinessUnit.EAM,
    [OrganizationName.OUI]: BusinessUnit.OUI,
};
exports.OrganizationSlugToBusinessUnit = {
    [OrganizationSlug.BOT]: BusinessUnit.BOT,
    [OrganizationSlug.EUD]: BusinessUnit.EUD,
    [OrganizationSlug.EAM]: BusinessUnit.EAM,
    [OrganizationSlug.OUI]: BusinessUnit.OUI,
    [OrganizationSlug.QDB]: BusinessUnit.EAM,
};
exports.BusinessUnitToBrandSlug = {
    [BusinessUnit.BOT]: 'boticario',
    [BusinessUnit.EUD]: 'eudora',
    [BusinessUnit.EAM]: 'quemdisseberenice',
    [BusinessUnit.OUI]: 'ouiparis',
};
exports.DomainBrandToBusinessUnit = {
    [exports.BusinessUnitToBrandSlug[BusinessUnit.BOT]]: BusinessUnit.BOT,
    [exports.BusinessUnitToBrandSlug[BusinessUnit.EUD]]: BusinessUnit.EUD,
    [exports.BusinessUnitToBrandSlug[BusinessUnit.EAM]]: BusinessUnit.EAM,
    [exports.BusinessUnitToBrandSlug[BusinessUnit.OUI]]: BusinessUnit.OUI,
};
exports.BusinessUnitToOrganizationSlug = {
    [BusinessUnit.BOT]: OrganizationSlug.BOT,
    [BusinessUnit.EUD]: OrganizationSlug.EUD,
    [BusinessUnit.EAM]: OrganizationSlug.EAM,
    [BusinessUnit.OUI]: OrganizationSlug.OUI,
    [BusinessUnit.MLT]: OrganizationSlug.EUD,
};
